import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProjectDetails from "../components/ProjectDetails/ProjectDetails";
import { vendorApi } from "../api/api";
import { render } from "@testing-library/react";
import ProjectPlotStructure from "../components/ProjectDetails/ProjectPlotStructure";
import ProjectImages from "../components/ProjectDetails/ProjectImages";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { updateReferrerId } from "../redux/reducers/Reducer";
import { useDispatch } from "react-redux";
import ProjectDocument from "../components/ProjectDetails/ProjectDocument";
import ProjectLayoutPage from "../components/ProjectDetails/ProjectLayoutPage";
import BookedProjectPlotDetails from "../components/BookedProperties/BookedProjectPlotDetails";
const SECRET_KEY = "yourSecretKey";
const BookedProjectDetailsScreen = () => {
  const userId = useSelector((state)=>state.user.userId);
  const referId = useSelector((state) => state.referer.ReffererId);
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
   const theme=useSelector((data)=>data.themeValue.colors);
  // const { projectId } = location.state || {};
  const [searchParams] = useSearchParams();
const { data} = location.state || {};
  const dispatch = useDispatch();
  const layoutConfig = [
   {
      id: "ProjectLayoutPage",
      render: () => <ProjectLayoutPage data={data}   />,
    },
    {
      id: "BookedProjectPlotStructure",
      render: () => <BookedProjectPlotDetails data={data}   />,
    },
    {
      id: "ProjectImages",
      render: () => <ProjectImages data={data} />
    },
    {
      id: "ProjectDocument",
      render: () => <ProjectDocument data={data.id} userId={userId} type={1}   />
    },
   
  ];
  return (
    <div style={styles.container}>
      {/* <h2 style={styles.heading}>Project Details</h2> */}
        <div style={styles.sectionWrapper}>
          {layoutConfig.map((section) => (
            <div key={section.id} style={{backgroundColor:theme.background,...styles.section}}>
              {section.render()}
            </div>
          ))}
        </div>
    </div>
  );
};
const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    padding: "10px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "24px",
    color: "#333",
  },
  loadingText: {
    fontSize: "16px",
    color: "#555",
    textAlign: "center",
    marginTop: "40px",
  },
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  section: {
    // padding: "20px",
    borderRadius: "12px",
    // backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    //  backgroundColor:"blue"
  },
};
export default BookedProjectDetailsScreen;